module.exports = __webpack_public_path__ + "img/LIGH BOX-1200x1200-GENERIC2.8a5b1f0a.gif";